export const getConnectionChannel = connectionLike => {
	const channel = String(connectionLike?.channel || connectionLike?.connection?.channel || "")
		.trim()
		.toLowerCase();
	const provider = String(connectionLike?.provider || connectionLike?.connection?.provider || "")
		.trim()
		.toLowerCase();
	const connectionType = String(connectionLike?.connectionType || "")
		.trim()
		.toLowerCase();
	const session = String(connectionLike?.session || connectionLike?.whatsapp?.session || "")
		.trim()
		.toLowerCase();
	const name = String(connectionLike?.name || connectionLike?.whatsapp?.name || "")
		.trim()
		.toLowerCase();

	if (channel === "webchat" || provider === "flowch_webchat" || connectionType === "webchat") {
		return "webchat";
	}

	if (channel === "facebook" || provider === "meta_facebook_messenger" || connectionType === "facebook") {
		return "facebook";
	}

	if (session.startsWith("webchat-") || name.includes("webchat")) {
		return "webchat";
	}

	return channel || "whatsapp";
};

export const getConnectionProvider = connectionLike => {
	const provider = String(connectionLike?.provider || connectionLike?.connection?.provider || "")
		.trim()
		.toLowerCase();
	const session = String(connectionLike?.session || connectionLike?.whatsapp?.session || "")
		.trim()
		.toLowerCase();

	if (provider) {
		return provider;
	}

	if (session.startsWith("official-")) {
		return "whatsapp_official";
	}

	if (session.startsWith("webchat-")) {
		return "flowch_webchat";
	}

	return "whatsapp_qr";
};

export const getConnectionPresentationKind = connectionLike => {
	const channel = getConnectionChannel(connectionLike);
	const provider = getConnectionProvider(connectionLike);

	if (channel === "webchat") {
		return "webchat";
	}

	if (channel === "facebook") {
		return "facebook";
	}

	if (provider === "whatsapp_official") {
		return "official";
	}

	if (channel === "whatsapp") {
		return "whatsapp";
	}

	return channel || "unknown";
};

export const normalizeConnectionStatus = connectionLike =>
	String(connectionLike?.status || connectionLike?.connection?.status || "")
		.trim()
		.toUpperCase();

export const isQrCodeConnection = connectionLike => {
	const channel = getConnectionChannel(connectionLike);
	const session = String(connectionLike?.session || connectionLike?.whatsapp?.session || "")
		.trim()
		.toLowerCase();
	const connectionType = String(connectionLike?.connectionType || "")
		.trim()
		.toLowerCase();

	return (
		channel === "whatsapp" &&
		connectionType !== "webchat" &&
		!session.startsWith("official-") &&
		!session.startsWith("webchat-")
	);
};

export const isQrCodeConnectionNeedingAttention = connectionLike => {
	if (!isQrCodeConnection(connectionLike)) {
		return false;
	}

	const status = normalizeConnectionStatus(connectionLike);
	const hasQrCode = Boolean(connectionLike?.qrcode || connectionLike?.whatsapp?.qrcode);

	return (
		hasQrCode ||
		["DISCONNECTED", "QRCODE", "TIMEOUT", "PAIRING"].includes(status)
	);
};

export const canStartOutboundAttendance = connectionLike => {
	const capabilities = connectionLike?.capabilities || connectionLike?.connection?.capabilities || {};
	const channel = getConnectionChannel(connectionLike);

	if (capabilities.canStartOutboundConversation === false) {
		return false;
	}

	if (capabilities.supportsManualOutbound === false) {
		return false;
	}

	return !["webchat", "facebook"].includes(channel);
};
